import { render, staticRenderFns } from "./CancelOrderModal.vue?vue&type=template&id=0e5485d8&scoped=true"
import script from "./CancelOrderModal.vue?vue&type=script&lang=ts"
export * from "./CancelOrderModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5485d8",
  null
  
)

export default component.exports